<template>
  <div class="call-phone-pop-up-container">
    <el-dialog
      title=""
      :visible.sync="callDialogVisible"
      class="formDialog"
      custom-class="call-phone-pop-up-box"
      width="800px"
      @close="closeCallPop"
    >
      <div slot="title" custom-class="dialog-title">
        <el-form
          :inline="true"
          :model="callPhoneInfo"
          class="demo-form-inline form-info"
        >
          <el-form-item label="被叫号码:" class="call-phone">
            <span class="call-phone-mobile">{{
              hidMobile(callUser.mobile)
            }}</span>
            <span class="call-phone-name" v-if="callUser.fullname"
              >({{ callUser.fullname }})</span
            >
          </el-form-item>
          <el-form-item label="上次跟进状态:" class="last-status">
            <div v-if="callUser.status == 0">未联系</div>
            <div v-else-if="callUser.status == 1">
              <span class="call-phone-last-status">未接通</span>
              <span class="call-phone-jietong"
                >({{ callUser.status_data.call_succ }}/{{
                  callUser.status_data.call_total
                }})</span
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="dial-box">
        <div v-if="callStatus == -1" class="is-not-call-box">
          <div class="is-not-call">
            <span class="is-not-call-pay">所剩余额不足，暂时无法呼叫</span>
            <div class="is-not-call-text">
              （帐户余额不能小于<span style="color: red">{{
                callErrorData.lowest_limit_price
              }}</span
              >)
            </div>
          </div>
          <div class="go-pay">
            <el-button @click="openKefu()">去充值</el-button>
          </div>
        </div>
        <div class="is-dial-box" v-show="callStatus == 0">
          <div class="dealing">拨号中...</div>
          <!-- <div class="hang-up" @click="hangUpFn">挂断</div> -->
        </div>
        <div class="hang-up-box" v-show="callStatus == 1">
          <div class="hang-up-info">
            <div class="hang-up">已挂断</div>
            <div class="call-time">
              通话时长：{{ callSuccessData.call_duration_txt }}
            </div>
            <div class="cost">
              总计费用{{ callSuccessData.compute_time }} X
              {{ callSuccessData.compute_ceil_price }} =
              <span>{{ callSuccessData.compute_total_price }}元</span>
            </div>
          </div>
          <div class="again-dial">
            <div @click="dialFn" class="again-dial-btn">重拨</div>
          </div>
        </div>
      </div>
      <div class="tag-input-box">
        <el-input
          v-model.trim="labelInput"
          placeholder="可点击选择下列标签或输入按回车键创建新标签"
          class="label-input"
          style="width: 100%"
          type="textarea"
          @keydown.enter.native="inputChangeLabel"
          @keydown.delete.native="deleteCheckLabel"
        ></el-input>
        <div class="tag">
          <el-tag
            v-for="(tag, index) in labelCheckLabel"
            :key="index"
            class="check-tag"
            closable
            @close="handleInputLabelClose(tag, index)"
          >
            {{ handerLabelLength(tag.name, 15) }}
          </el-tag>
        </div>
      </div>
      <div class="label-list-box">
        <div class="label-change">选择标签</div>
        <div class="label-list">
          <div class="icon-left">
            <i
              class="el-icon-arrow-left change"
              @click="leftLabel"
              v-show="labelQuery.page !== 0"
            ></i>
          </div>
          <div class="tag-list">
            <el-tag
              v-for="(tag, index) in labelList"
              :key="index"
              effect="plain"
              :type="tag.color"
              @click="changeLabel(tag)"
              class="tag-item"
            >
              {{ handerLabelLength(tag.name, 15) }}
            </el-tag>
          </div>
          <div class="icon-right">
            <i
              class="el-icon-arrow-right change"
              @click="rightLabel"
              v-show="labelQuery.rightV"
            ></i>
          </div>
        </div>
      </div>
      <div class="remark-title">添加备注</div>
      <el-input
        v-model.trim="callUser.remark"
        :placeholder="remarkTip"
        class="remark-input"
        style="width: 100%"
        type="textarea"
        maxlength="50"
        show-word-limit
        @focus="remarkTip = ''"
        @blur="remarkTip = '输入备注内容'"
      ></el-input>
      <!-- 脚部 -->
      <div slot="footer">
        <div class="btn-box">
          <el-button @click="saveRemark">保存</el-button>
          <el-button type="primary" @click="callNext">呼叫下一位</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import studentApi from "@/api/student.js";
import callPhoneApi from "@/api/callphone";
import commonApi from "@/api/common";
import { deepClone } from "@/utils";
export default {
  name: "callPhonePopUp", // 呼叫弹窗组件
  props: {
    // 弹窗显示状态
    callDialogVisible: {
      type: Boolean,
      default: false,
    },
    // 被叫用户信息
    callUser: {
      type: Object,
    },
    // 自己的信息
    myUser: {
      type: Object,
    },
  },
  created() {
    this.callUser = deepClone(this.callUser);
    // 获取自定义标签
    this.getAllLabel();
    if (this.callUser.tags.length !== 0) {
      this.changeInputSize();
    }
    // 将备注存储以便提交的时候对比
    this.remark = this.callUser.remark;
    this.callUser.remark = "";
    // 开始呼叫
    this.dialFn();
  },
  data() {
    return {
      // 呼叫号码信息
      callPhoneInfo: {
        mobile: "", // 被叫手机号
        name: "", // 被叫姓名
        lastStatus: 1, // 上次跟进状态
      },
      // 是否是拨号状态
      isDial: true,
      // 标签输入内容
      labelInput: "",
      // 用户可选标签
      labelList: [],
      // 标签对象
      labelListObj: {
        publicLabel: [], //公共标签
        diyLabel: [], // 自定义标签
        allLabel: [], // 总的标签
      },
      // 用户选中标签
      labelCheckLabel: [],
      // 标签页的请求信息
      labelQuery: {
        limit: 6,
        total: 0,
        page: 0,
        rightV: false,
      },
      // 备注信息
      remark: "",
      // 备注提示
      remarkTip: "输入备注内容",
      // 呼叫成功的数据
      callSuccessData: {},
      callQueryTimer: "",
      callStatus: "", // 呼叫状态 -1接口失败 0：通话中， 1：已挂断
      callErrorData: {},
    };
  },
  methods: {
    // 关闭弹窗
    closeCallPop() {
      this.$emit("closeCallPop");
    },
    // 挂断电话
    hangUpFn() {
      console.log("挂断");
      this.callStatus = 1;
    },
    // 重新拨号
    async dialFn() {
      // this.callStatus = 0;
      // console.log('dialFn', this.myUser, this.callUser)
      // 开始呼叫
      if (this.callUser) {
        callPhoneApi.callPhone({ id: this.callUser.id }).then((res) => {
          console.log("res", res);
          if (res.code === 200) {
            this.callSuccessData.bindId = res.data.bindId;
            this.callSuccessData.crm_id = res.data.crm_id;
            this.callStatus = 0;
            this.startCallStatusQuery();
          } else if (res.code === 402) {
            this.callErrorData = res.data;
            this.callStatus = -1;
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 通过输入框创建新标签
    inputChangeLabel() {
      if (!this.labelInput) {
        return;
      }
      if (
        this.labelCheckLabel.find((item) => item.name === this.labelInput) !==
        undefined
      ) {
        // 如果用户输入的标签和已经添加到输入框的标签一致，则返回错误并结束函数
        this.$message("已经选择过该标签了");
        return;
      } else if (
        this.labelListObj.publicLabel.find((item) => {
          if (item.name === this.labelInput) {
            item.color = "";
            return true;
          }
        }) !== undefined ||
        this.labelListObj.diyLabel.find((item) => {
          if (item.name === this.labelInput) {
            item.color = "";
            return true;
          }
        }) !== undefined
      ) {
        const pubTemp = this.labelListObj.publicLabel.find((item) => {
          if (item.name === this.labelInput) {
            item.color = "";
            return true;
          }
        });
        const diyTemp = this.labelListObj.diyLabel.find((item) => {
          if (item.name === this.labelInput) {
            item.color = "";
            return true;
          }
        });
        if (pubTemp) {
          // 如果用户输入的标签和已经存在的标签一致，则直接添加
          this.labelCheckLabel.push({ name: pubTemp.name, id: pubTemp.id });
        } else {
          // 如果用户输入的标签和已经存在的标签一致，则直接添加
          this.labelCheckLabel.push({ name: diyTemp.name, id: diyTemp.id });
        }
        this.labelInput = "";
        this.changeInputSize();
        return;
      } else {
        studentApi.tobTagsAdd({ name: this.labelInput }).then((res) => {
          if (res.code === 200) {
            if (
              this.labelQuery.total /
                (this.labelQuery.page * this.labelQuery.limit) <=
                1 &&
              this.labelQuery.page > 0 &&
              this.labelList.length < 6
            ) {
              // 用户输入的标签是之前没有的，就添加到待选择标签
              this.labelList.push({
                ...res.data,
                color: "",
              });
              this.labelListObj.diyLabel.push({
                ...res.data,
                color: "",
              });
              this.labelCheckLabel.push({
                ...res.data,
              });
              this.changeInputSize();
            } else {
              // 用户输入的标签是之前没有的，就添加到待选择标签
              this.labelListObj.diyLabel.push({
                ...res.data,
                color: "",
              });
              this.labelCheckLabel.push({
                ...res.data,
              });
              this.changeInputSize();
              this.labelQuery.rightV = true;
            }
            this.labelQuery.total++;
            this.labelInput = "";
            this.$message({
              type: "success",
              message: "标签新建成功",
            });
          } else {
            this.$message(res.message);
          }
        });
      }
    },
    // 改变输入框尺寸
    changeInputSize() {
      this.$nextTick(() => {
        // 获取当前有几行标签
        let hang = Math.ceil(this.labelCheckLabel.length / 3);
        if (document.body.clientWidth < 979) {
          hang = Math.ceil(this.labelCheckLabel.length / 2);
        }
        // 获取到已经选中标签的最后一个标签
        let el = document.querySelector(".check-tag:first-child");
        if (!el) {
          return;
        } else {
          // offsetTop 子元素的外边框到父元素的内边框的垂直距离
          let top = el.offsetTop + el.clientHeight * hang + 7 * hang;
          // 让输入光标处于选中标签最后一行的下方
          document.querySelector(
            ".label-input  .el-textarea__inner"
          ).style.paddingLeft = 10 + "px";
          document.querySelector(
            ".label-input  .el-textarea__inner"
          ).style.paddingTop = top + 10 + "px";
          // input框高度超出选中tag高度一行的距离
          document.querySelector(
            ".label-input  .el-textarea__inner"
          ).style.minHeight = top + el.clientHeight + 10 + "px";
        }
      });
    },
    // 选择标签
    changeLabel(tag) {
      // 是否已选择
      const tempLabel = this.labelCheckLabel.find(
        (item) => item.name === tag.name
      );
      // 选择过直接返回
      if (tempLabel !== undefined) {
        this.$message("已经选择过该标签了");
        return;
      } else {
        // 没有选择过就加入被选
        const addLabel = [
          ...this.labelListObj.publicLabel,
          ...this.labelListObj.diyLabel,
        ].find((item) => item.name === tag.name);
        this.labelCheckLabel.push(addLabel);
        this.labelList.forEach((item) => {
          if (item.name === addLabel.name) {
            item.color = "";
          }
        });
        // 改变选中颜色
        addLabel.color = "";
        console.log(addLabel);
        this.changeInputSize();
      }
    },
    // 删除选中的标签
    handleInputLabelClose(tag, index) {
      // 改变被删除标签在待选区的样式
      for (const item in this.labelList) {
        if (this.labelList[item].name === tag.name) {
          this.labelList[item].color = "info";
          break;
        }
      }
      for (const item in this.labelListObj.diyLabel) {
        if (this.labelListObj.diyLabel[item].name === tag.name) {
          this.labelListObj.diyLabel[item].color = "info";
          // break;
        }
      }
      for (const item in this.labelListObj.publicLabel) {
        if (this.labelListObj.publicLabel[item].name === tag.name) {
          this.labelListObj.publicLabel[item].color = "info";
          // break;
        }
      }
      this.labelCheckLabel.splice(index, 1);
      this.changeInputSize();
    },
    // 标签页向左翻页
    leftLabel() {
      this.labelQuery.page--;
      this.labelQuery.rightV = true;
      if (this.labelQuery.page === 0) {
        this.labelList = this.labelListObj.publicLabel;
      } else {
        this.labelList = this.labelListObj.diyLabel.slice(
          (this.labelQuery.page - 1) * this.labelQuery.limit,
          this.labelQuery.page * this.labelQuery.limit
        );
      }
    },
    // 标签页向右边翻页
    rightLabel() {
      this.labelQuery.page++;
      if (this.labelQuery.page > 0) {
        if (
          this.labelQuery.total /
            (this.labelQuery.page * this.labelQuery.limit) <=
          1
        ) {
          this.labelQuery.rightV = false;
        }
        this.labelList = this.labelListObj.diyLabel.slice(
          (this.labelQuery.page - 1) * this.labelQuery.limit,
          this.labelQuery.page * this.labelQuery.limit
        );
      }
    },
    // 保存备注或标签信息
    saveRemark() {
      if (this.remark === this.callUser.remark && this.remark) {
        this.$message("该备注已保存");
        return;
      } else if (
        this.labelCheckLabel.length === 0 &&
        this.callUser.remark === ""
      ) {
        this.$message("请选择标签或输入备注");
      }
      if (this.labelCheckLabel.length !== 0) {
        // 保存标签
        this.updateLabel();
      }
      if (this.callUser.remark) {
        // 保存备注
        this.updateRemark();
      }
    },
    // 向上抛出呼叫下一位的信号
    callNext() {
      this.$emit("callNext");
    },
    // 获取所有标签
    getAllLabel() {
      studentApi
        .studentsTags({ uid: this.callUser.id, type: 1 })
        .then((res) => {
          if (res.code === 200) {
            this.callUser.tags = res.data.own;
            this.labelCheckLabel = this.callUser.tags;
            console.log("all", res);
            this.changeInputSize();
            // 判断用户已有标签中有没有自定义的标签，添加对应激活样式
            res.data.data.forEach((item) => {
              if (
                this.callUser.tags.find((ele) => ele.name === item.name) !==
                undefined
              ) {
                item.color = "";
              } else {
                item.color = "info";
              }
            });
            // 自定义标签
            this.labelListObj.diyLabel = res.data.data.filter(
              (item) => item.is_common_tag === 0
            );
            //公共标签
            this.labelListObj.publicLabel = res.data.data.filter(
              (item) => item.is_common_tag === 1
            );
            if (this.labelListObj.publicLabel.length === 0) {
              // 公共标签没有。将自定义标签前六位放公共（后写的代码偷懒），六位之后放入自定义标签
              this.labelListObj.publicLabel = this.labelListObj.diyLabel.slice(
                0,
                6
              );
              this.labelListObj.diyLabel = this.labelListObj.diyLabel.slice(6);
              this.labelList = this.labelListObj.publicLabel;
              this.labelQuery.total = this.labelListObj.diyLabel.length;
            } else {
              // 公共标签有
              if (this.labelListObj.publicLabel.length > 6) {
                // 公共标签数量大于6
                this.labelListObj.diyLabel = [
                  ...this.labelListObj.publicLabel.slice(6),
                  ...this.labelListObj.diyLabel,
                ];
                this.labelListObj.publicLabel =
                  this.labelListObj.publicLabel.slice(0, 6);
                this.labelList = this.labelListObj.publicLabel;
              } else {
                // 公共标签数量小于6
                this.labelList = this.labelListObj.publicLabel;
              }
              this.labelQuery.total = this.labelListObj.diyLabel.length;
            }
            // 如果初始时右边没有数据了，不显示右边翻页
            if (this.labelQuery.total === 0) {
              this.labelQuery.rightV = false;
            } else {
              this.labelQuery.rightV = true;
            }
          }
        });
    },
    // 加密手机号
    hidMobile(mobile) {
      const arr = mobile.split("");
      arr.splice(3, 6, "******");
      return arr.join("");
    },
    // 删除最后一个标签
    deleteCheckLabel() {
      if (this.labelCheckLabel.length === 0 || this.labelInput !== "") {
        return;
      } else {
        this.handleInputLabelClose(
          this.labelCheckLabel[this.labelCheckLabel.length - 1],
          this.labelCheckLabel.length - 1
        );
      }
    },
    // 添加标签
    updateLabel() {
      const submitLabelList = this.labelCheckLabel.map((item) => item.id);
      callPhoneApi
        .updateUser({
          id: this.callUser.id,
          tag_id: submitLabelList.join(","),
        })
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "标签保存成功!",
            });
          } else {
            this.$message(res.message);
          }
        });
    },
    // 更新备注
    updateRemark() {
      commonApi
        .remarkDo({
          crm_users_id: this.callUser.id,
          remark: this.callUser.remark,
        })
        .then((res) => {
          if (res.code === 200) {
            // 以防止重复提交一样的备注
            this.remark = this.callUser.remark;
            this.$message({
              type: "success",
              message: "备注保存成功!",
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
    },
    // 开启呼叫状态轮询
    startCallStatusQuery() {
      if (this.callQueryTimer) {
        clearInterval(this.callQueryTimer);
        this.callQueryTimer = "";
      }
      this.callQueryTimer = setInterval(async () => {
        let res = await callPhoneApi.callStatusQuery({
          crm_id: this.callSuccessData.crm_id,
          bindId: this.callSuccessData.bindId,
        });
        if (res.code === 200) {
          this.callSuccessData.call_duration = res.data.call_duration;
          this.callSuccessData.call_duration_txt = res.data.call_duration_txt;
          this.callSuccessData.compute_time = res.data.compute_time;
          this.callSuccessData.compute_ceil_price = res.data.compute_ceil_price;
          this.callSuccessData.compute_total_price =
            res.data.compute_total_price;
          this.callSuccessData.is_pay = res.data.is_pay;
          this.callSuccessData.import_user_first_free_txt =
            res.data.import_user_first_free_txt;
          if (res.data.status == 1) {
            this.callStatus = 1; // 已挂断
            // 已挂断
            clearInterval(this.callQueryTimer);
            this.callQueryTimer = "";
          }
        } else {
          clearInterval(this.callQueryTimer);
          this.callQueryTimer = "";
        }
      }, 5000);
    },
    // 向上抛出打开客服弹窗
    openKefu() {
      this.$emit("closeCallPop", "kefu");
    },
    // 处理标签字符长度
    handerLabelLength(label, maxLen) {
      // 屏幕宽度为移动设备时最大字符数量为8
      if (document.body.clientWidth < 979) {
        let maxLen = 8;
        // 当标签内容大于最大字符数时，判断标签内容的字节数，最多显示最大字符数两倍的字节数量（避免显示格式错乱）
        if (label.length > maxLen) {
          const { len, index } = this.getStrLen(label, maxLen);
          if (len >= maxLen * 2 - 1) {
            return label.slice(0, index) + '...';
          } else {
            return label;
          }
        } else {
          return label;
        }
      } else {
        if (label.length > maxLen) {
          const { len, index } = this.getStrLen(label, maxLen);
          if (len >= maxLen - 1) {
            return label.slice(0, index)  + '...';
          } else {
            return label;
          }
        } else {
          return label;
        }
      }
    },
    // 获取字符串字节长度
    getStrLen(str, maxLen) {
      let len = 0;
      let index = 0;
      for (let i = 0; i < str.length; i++) {
        str.charCodeAt(i) < 256 ? (len += 1) : (len += 2);
        if (len >= maxLen * 2 - 1) {
          index = i + 1;
          return {
            index,
            len,
          };
        }
      }
      return {
        len,
        index,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.call-phone-pop-up-container {
  width: 100%;
}
/deep/ .el-dialog__header {
  .form-info {
    font-weight: bolder;
    .call-phone {
      margin-right: 60px;
      .call-phone-mobile {
        margin-right: 6px;
      }
    }
  }
}
/deep/ .el-dialog__body {
  .dial-box {
    width: 100%;
    height: 120px;
    .is-not-call-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      .is-not-call {
        margin-bottom: 15px;
        text-align: center;
        .is-not-call-pay {
          font-size: 25px;
        }
        .is-not-call-text {
          font-size: 16px;
        }
      }
    }

    .is-dial-box {
      display: flex;
      justify-content: center;
      flex-direction: row;
      height: 100%;
      .dealing {
        // font-weight: bold;
        font-size: 50px;
        margin-right: 40px;
        height: 100%;
      }
      .hang-up {
        font-size: 25px;
        color: blue;
        cursor: pointer;
      }
    }
    .hang-up-box {
      display: flex;
      justify-content: center;
      flex-direction: row;
      height: 120px;
      .hang-up-info {
        display: flex;
        justify-content: start;
        align-items: center;
        flex-direction: column;
        margin-right: 40px;
        .hang-up {
          font-size: 25px;
          margin-bottom: 30px;
        }
        .call-time {
          margin-bottom: 8px;
        }
      }
      .again-dial {
        .again-dial-btn {
          font-size: 25px;
          color: blue;
          cursor: pointer;
        }
      }
      .cost {
        span {
          color: #f40;
        }
      }
    }
  }
  // .label-input {
  //   width: 100%;
  //   margin-top: 15px;
  // }
  .label-list-box {
    display: flex;
    justify-content: start;
    margin-top: 30px;
    height: 90px;
    .label-change {
      margin-right: 20px;
      width: 70px;
      line-height: 30px;
    }
    .label-list {
      flex: 1;
      display: flex;
      justify-content: space-between;
      .icon-left {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        width: 30px;
        box-sizing: border-box;
        .change {
          cursor: pointer;
        }
      }
      .icon-right {
        box-sizing: border-box;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 30px;
        .change {
          cursor: pointer;
        }
      }
      .tag-list {
        // display: flex;
        // justify-content: space-around;
        padding-left: 30px;
        width: 100%;
        .el-tag {
          display: inline-block;
          width: 30%;
          overflow: hidden;
        }
      }
    }
    .el-tag {
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  .tag-input-box {
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    .label-input {
    }
    .tag {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      width: 100%;
      display: flex;
      flex-shrink: 0;
      flex-flow: wrap;
      .check-tag {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 5px;
        margin-top: 5px;
        width: 30%;
      }
    }
  }
  .remark-title {
    margin-top: 20px;
  }
  .remark-input {
    margin-top: 20px;
  }
}

@media (max-width: 979px) {
  /deep/.label-list-box {
    display: block !important;
    margin-top: 0 !important;
    height: 140px !important;
  }
  /deep/ .label-list {
    margin: 5px;
  }
  /deep/ .el-tag {
    width: 44% !important;
  }
  /deep/ .dial-box {
    height: 50px !important;
    margin-bottom: 20px !important;
  }
  /deep/ .dealing {
    font-size: 25px !important;
  }
  /deep/ .hang-up-box {
    height: 50px !important;
  }
  /deep/ .is-not-call {
    display: flex !important;
    margin-bottom: 0 !important;
  }
  /deep/ .is-not-call-pay {
    font-size: 14px !important;
  }
  /deep/ .is-not-call-text {
    font-size: 14px !important;
  }
  /deep/ .icon-right {
    height: 126px !important;
  }
  /deep/ .icon-left {
    height: 126px !important;
  }
}

/deep/ .el-dialog__footer {
  .btn-box {
    margin: 20px 0;
    display: flex;
    justify-content: space-around;
  }
}
</style>